import { cn } from '@/lib/cn';
import { highPriorityImage } from '@/lib/img';
import { es } from '@/i18n/es';

interface WordmarkProps {
  /** Alto en clases de Tailwind. El ancho lo resuelve la proporción. */
  className?: string;
}

/**
 * Logotipo de la marca.
 *
 * Es una imagen y no texto, así que lleva `alt` con el nombre: para un lector
 * de pantalla tiene que sonar igual que antes, cuando era una palabra.
 *
 * Se sirve al doble del tamaño en que se muestra, para que no se vea blando en
 * pantallas de alta densidad. El `width`/`height` reserva el espacio antes de
 * que la imagen cargue y evita que el header salte.
 */
export function Wordmark({ className }: WordmarkProps) {
  return (
    <img
      src="/logotipo.webp"
      alt={es.app.name}
      width={600}
      height={211}
      decoding="async"
      // Está arriba de todo en cada pantalla: se pide con prioridad en vez de
      // competir con lo que viene después.
      {...highPriorityImage}
      className={cn('w-auto select-none', className)}
    />
  );
}
